// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TkhXZ","newExpiryDate":"styles_newExpiryDate__2Djot","footer":"styles_footer__dscy6"};